
import TextArea from 'antd/es/input/TextArea'
import React, { useContext, useState } from 'react'
import ExpertDataContext from '../../../../../context/expertDataContext';


function AboutModal(text) {
  const { expertDataAction } = useContext(ExpertDataContext);

  const handleChange = (name, value) => {
    expertDataAction(name, value);
  };

  return (
    <div className='py-5'>
        <TextArea onChange={(e)=> handleChange('aboutMe', e?.target?.value)} defaultValue={text.text}  autoSize={{minRows:5,maxRows:10}} maxLength={1500} showCount={true} placeholder='یادداشت خود را بنویسید ...'/>
    </div>
  )
}

export default AboutModal